module.exports = __webpack_public_path__ + "media/images/zj11-w4-07e000f773b6f8a5f800bda977575bf5.png";